import React from 'react';

function TextRightIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M13 3h8M13 9h8M3 15h18M3 21h18'
			></path>
		</svg>
	);
}

export default TextRightIcon;
